import { useCallback } from 'react';
import UserManagementService from '../../../../services/UserManagement.service';
import UserService from '../../../../services/UserService';
import DCDPOService from '../../../../services/DCDPO.service';
import DataBreachService from '../../../../services/DataBreach.service';

export default function useDownlaod(id) {
    const uid = UserService.getUi();

    const getUserDetail = useCallback(async () => {
        try {
            const { data } = await UserManagementService.getUserDetail(uid);
            const item = data?.resultData;
            return item;
        } catch (error) {
            console.log(error);
        }
    }, [uid]);

    const getDCDPO = useCallback(async () => {
        try {
            const { data } = await DCDPOService.getDCDPO();
            const item = data?.resultData;
            return item;
        } catch (error) {
            console.log(error);
        }
    }, []);

    const getConsequence = useCallback(async () => {
        try {
            const { data } = await DataBreachService.getConsequenceDetail(id);
            if (data?.resultData) {
                const parsedAnswer = JSON.parse(data.resultData.answer);
                return parsedAnswer;
            }
        } catch (error) {
            console.log(error);
        }
    }, [id]);

    const getInformingDetail = useCallback(async () => {
        try {
            const { data } = await DataBreachService.getInformingDetail(id);
            if (data?.resultData) {
                // return parsedAnswer only sequence 5 and 6
                const filteredItems = data?.resultData.filter(
                    (item) => item.sequence === 5 || item.sequence === 6
                );
                const answer501 = filteredItems.find(
                    (item) => item.sequence === 5
                );
                const answer502 = filteredItems.find(
                    (item) => item.sequence === 6
                );
                return {
                    answer501: answer501?.answerTh,
                    answer502: answer502?.answerTh,
                };
            }
        } catch (error) {
            console.log(error);
        }
    }, [id]);

    return {
        getInformingDetail,
        getConsequence,
        getUserDetail,
        getDCDPO,
    };
}
